enum MachineFilterConstants {
  FREE_TEXT_FILTER_NAME = 'free_text',
  TAGS_FILTER_NAME = 'tags',
  GET_FILTER_DEFINITIONS = '@MachineFilterV2/GET_FILTER_DEFINITIONS',
  GET_FILTER_DEFINITIONS_REQUEST = '@MachineFilterV2/GET_FILTER_DEFINITIONS_REQUEST',
  GET_FILTER_DEFINITIONS_REQUEST_SUCCESS = '@MachineFilterV2/GET_FILTER_DEFINITIONS_REQUEST_SUCCESS',
  GET_FILTER_DEFINITIONS_REQUEST_ERROR = '@MachineFilterV2/GET_FILTER_DEFINITIONS_REQUEST_ERROR',

  GET_SAVED_FILTERS = '@MachineFilterV2/GET_SAVED_FILTERS',
  GET_SAVED_FILTERS_REQUEST = '@MachineFilterV2/GET_SAVED_FILTERS_REQUEST',
  GET_SAVED_FILTERS_REQUEST_SUCCESS = '@MachineFilterV2/GET_SAVED_FILTERS_REQUEST_SUCCESS',
  GET_SAVED_FILTERS_REQUEST_ERROR = '@MachineFilterV2/GET_SAVED_FILTERS_REQUEST_ERROR',

  SAVE_NEW_FILTER = '@MachineFilterV2/SAVE_NEW_FILTER',
  SAVE_NEW_FILTER_REQUEST = '@MachineFilterV2/SAVE_NEW_FILTER_REQUEST',
  SAVE_NEW_FILTER_REQUEST_SUCCESS = '@MachineFilterV2/SAVE_NEW_FILTER_REQUEST_SUCCESS',
  SAVE_NEW_FILTER_REQUEST_ERROR = '@MachineFilterV2/SAVE_NEW_FILTER_REQUEST_ERROR',

  EDIT_SAVED_FILTER = '@MachineFilterV2/EDIT_SAVED_FILTER',
  EDIT_SAVED_FILTER_REQUEST = '@MachineFilterV2/EDIT_SAVED_FILTER_REQUEST',
  EDIT_SAVED_FILTER_REQUEST_SUCCESS = '@MachineFilterV2/EDIT_SAVED_FILTER_REQUEST_SUCCESS',
  EDIT_SAVED_FILTER_REQUEST_ERROR = '@MachineFilterV2/EDIT_SAVED_FILTER_REQUEST_ERROR',

  REMOVE_SAVED_FILTER = '@MachineFilterV2/REMOVE_SAVED_FILTER',
  REMOVE_SAVED_FILTER_REQUEST = '@MachineFilterV2/REMOVE_SAVED_FILTER_REQUEST',
  REMOVE_SAVED_FILTER_REQUEST_SUCCESS = '@MachineFilterV2/REMOVE_SAVED_FILTER_REQUEST_SUCCESS',
  REMOVE_SAVED_FILTER_REQUEST_ERROR = '@MachineFilterV2/REMOVE_SAVED_FILTER_REQUEST_ERROR',

  ADD_FILTER_VALUE = '@MachineFilterV2/ADD_FILTER_VALUE',
  REMOVE_FILTER_VALUE = '@MachineFilterV2/REMOVE_FILTER_VALUE',
  CLEAR_ALL_FILTER_VALUES = '@MachineFilterV2/CLEAR_ALL_FILTER_VALUES',
  CLEAR_FILTER_VALUES_BY_NAME = '@MachineFilterV2/CLEAR_FILTER_VALUES_BY_NAME',
  SET_FILTER_VALUES = '@MachineFilterV2/SET_FILTER_VALUES',

  APPLY_SAVED_FILTER = '@MachineFilterV2/APPLY_SAVED_FILTER',

  PARSE_SEARCH_AND_GET_FILTER_DEFINITIONS = '@MachineFilterV2/PARSE_SEARCH_AND_GET_FILTER_DEFINITIONS',
  SET_VISIBILITY_FILTER = '@MachineFilterV2/SET_VISIBILITY_FILTER',
  CLEAR_VISIBILITY_FILTER = '@MachineFilterV2/CLEAR_VISIBILITY_FILTER',
}

export default MachineFilterConstants;
